import * as Yup from "yup";

export const schema = Yup.object().shape({
  search: Yup.string()
});

interface FormValues {
  search: string;
}

export const initialValues: FormValues = {
  search: ''
};
